import React, { useMemo } from 'react'
import { line as d3Line } from 'd3-shape'
import styled from '@emotion/styled'
import { isEmpty, compact } from 'lodash'
import { useTheme } from 'emotion-theming'

const SvgTag = styled('svg')`
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  pointer-events: none;
`

const Path = styled('path')`
  stroke-opacity: 1;
  stroke-width: 1;
  fill: none;
`

const lineY = 22
const lineHeight = 61

const buildPath = d3Line()
  .x(point => point.x)
  .y(point => point.y)

const Svg = ({ width, height, rowNodesWithLayoutState, isPrimaryParent, isSecondaryParent, selection }) => {
  const theme = useTheme()

  const testPrimary = !isPrimaryParent && selection.length >= 1
  const testSecondary = !isSecondaryParent && selection.length === 2

  const pathPrimary = useMemo(() => {
    if (!testPrimary) return null
    const points = rowNodesWithLayoutState.map((row, i) => {
      const primaryNode = row.find(node => selection[0].id === node.data.id)
      return {
        x: primaryNode.x,
        y: lineY + lineHeight * i
      }
    })
    if (isEmpty(compact(points))) return ''
    return buildPath(points)
  }, [rowNodesWithLayoutState, selection, testPrimary])

  const pathSecondary = useMemo(() => {
    if (!testSecondary) return null
    const points = rowNodesWithLayoutState.map((row, i) => {
      const secondaryNode = row.find(node => selection[1].id === node.data.id)
      return {
        x: secondaryNode.x,
        y: lineY + lineHeight * i
      }
    })
    if (isEmpty(compact(points))) return ''
    return buildPath(points)
  }, [rowNodesWithLayoutState, selection, testSecondary])

  return (
    <SvgTag width={width} height={height}>
      {testPrimary && (
        <Path
          d={pathPrimary}
          stroke={theme.tonic}
        />
      )}
      {testSecondary && (
        <Path
          d={pathSecondary}
          stroke={theme.white}
        />
      )}
    </SvgTag>
  )
}

export default Svg
